import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import kfcbasket from "../../Assetes/Images/kfc-basket2.svg"
import KfcMeal from "../../Assetes/Images/kfc-meal.png"
import mergn from 'mergn-webapp-sdk'
import CartItems from './CartItems'
import { useSelector } from 'react-redux';
import { priceunit } from '../../Components/client-config';
import useTrackEvent from '../../hooks/useTrackHook';
import useCurrentLocale from '../../hooks/useLanguage'
import { useTranslation } from 'react-i18next'

export default function CartCategory(props: any) {
    const cartData = useSelector((state: any) => state.cart.cartData);
    const cartQty = useSelector((state: any) => state.cart.cartQty);
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    const lang = useCurrentLocale();
    const { t } = useTranslation();

    const [value, setValue] = useState(0)
    const [isSticky, setIsSticky] = useState(true)
    const [addEvent] = useTrackEvent();
    useEffect(() => {
        window.onscroll = function (ev) {
            if ((window.innerHeight + window.scrollY + 393) >= document.body.offsetHeight) {
                setIsSticky(false)
            } else {
                setIsSticky(true)
            }
        };
    }, [])
    useEffect(() => {
        // forcefully render cart on add to cart items
        setValue(value + 1)
    }, [props.headerUpdate])
    const calcItemTotal = (carts: any) => {
        let sum = 0;
        carts.forEach((item: any) => {
            sum += parseInt(item.totalItemPrice);
        });
        return sum;
    };

    function eventsFired() {
        addEvent({ category: "events", events: "View Bucket" })
        mergn.recordEvent('Cart Click')
    }

    return (
        <>
            <div className="basket-conainet-sticky">
                <div className='basket-items'>
                    <div className='item-add'>
                        {cartQty > 0 ?
                            <h3>{storeSelected? cartQty:0} {cartQty > 1 ? t("ITEMS") : t("ITEM")} {t("ADDED")}</h3>
                            :
                            <h3>{t("ORDER_DETAILS")}</h3>}
                        <div className='kfc-box-theme'>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <div className='add-to-basket'>
                      
                        {(cartData && cartData.length > 0 && storeSelected) ? cartData.map((carts: any, index: any) => {
                            return <CartItems carts={carts} index={index} setValue={setValue} value={value} setHeaderUpdate={props.setHeaderUpdate} headerUpdate={props.headerUpdate}/>
                        }) : <div className='kfc-basket' style={{ aspectRatio: 0 }}>
                             <img src={KfcMeal} alt="" />
                            <h5 className='color-white mt-4 font-bold'>{t("NO_ITEMS_IN_BUCKET")}</h5>
                        </div>}
                    </div>

                </div>
                <Link to={`/${lang}/bucket`}>
                    <div onClick={() => eventsFired()} className="kfc-card-price">
                        <div className='d-flex justify-content-between'>
                            <div className='d-flex align-items-center gap-10'>
                                <h6 className='font-normal mb-0'>{storeSelected? cartQty:0} {cartData.length > 1 ? t("ITEMS") : t("ITEM")}</h6>
                                <h5 className='kfc-mmm'>| {storeSelected?priceunit + calcItemTotal(cartData):priceunit+0}</h5>
                            </div>
                            <div className='d-flex align-items-center'>
                                <h6 className='kfc-mmm px-2'>{t("VIEW_BUCKET")}</h6>
                                <i className="ri-arrow-right-s-line errow-line web-errow"></i>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <Link to={`/${lang}/bucket`}>
                <div onClick={() => eventsFired()} className='mobile-cart'>
                    <div className='d-flex justify-content-between align-items-baseline'>
                        <div className='d-flex align-items-center gap-10'>
                            <h6 className='font-normal mb-0'>{storeSelected? cartQty:0} {cartData.length > 1 ? t("ITEMS") : t("ITEM")}</h6>
                            <h5 className='kfc-mmm'>| {storeSelected?priceunit + calcItemTotal(cartData):priceunit+0}</h5>
                        </div>
                        <div className='d-flex align-items-center '>
                            <h6 className='kfc-mmm px-2'>{t("VIEW_BUCKET")}</h6>
                            <i className="ri-arrow-right-s-line errow-line"></i>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}
